import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "services-container" }
const _hoisted_2 = { class: "services-list" }
const _hoisted_3 = { class: "service-icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "service-details" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "page-title" }, "Network & Administration Consultancy Services", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "service-item"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: service.icon,
              alt: "service-icon"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", null, _toDisplayString(service.name), 1),
            _createElementVNode("p", null, _toDisplayString(service.description), 1),
            _createElementVNode("a", {
              href: service.link,
              class: "service-link"
            }, "Learn More", 8, _hoisted_6)
          ])
        ]))
      }), 128))
    ])
  ]))
}